import instance from "../../api";
import {GetReceiptParams, GetReceiptResponse} from "./types";

export const getDataWith1C = async (params: GetReceiptParams): Promise<GetReceiptResponse> => {
  return await instance()
    .get("/core/commons/one_c_compare/", {params})
    .then((res) => res?.data);
};